// Perfis e permissões do CRM

export const PERFIS = {
  admin: {
    label: "Admin",
    emoji: "⚡",
    color: "#E8520A",
    descricao: "Acesso total ao sistema",
    paginas: ["prontuarios", "leads", "pacotes", "agenda", "faltas", "espera", "painel", "kanban", "negociacoes", "projetos", "financeiro", "relatorios", "historico", "calendario", "dashboard", "gestao", "vendas", "comissoes", "clientes", "orcamentos", "produtos", "usuarios", "configuracoes", "integracoes", "privacidade", "atividades", "financa", "rh"],
    podeEditar: true,
    veLeadsDeTodos: true,
    podeCriarUsuarios: true,
    podeExcluir: true,
  },
  financeiro: {
    label: "Financeiro",
    emoji: "💰",
    color: "#0ea5e9",
    descricao: "Vê tudo, exceto gestão de usuários",
    paginas: ["prontuarios", "leads", "pacotes", "agenda", "faltas", "espera", "painel", "kanban", "negociacoes", "projetos", "financeiro", "relatorios", "calendario", "dashboard", "vendas", "clientes", "orcamentos", "produtos", "atividades", "rh"],
    podeEditar: true,
    veLeadsDeTodos: true,
    podeCriarUsuarios: false,
    podeExcluir: true,
  },
  gerente: {
    label: "Gerente",
    emoji: "👔",
    color: "#8b5cf6",
    descricao: "Vê tudo exceto configurações e usuários",
    paginas: ["prontuarios", "leads", "pacotes", "agenda", "faltas", "espera", "painel", "kanban", "negociacoes", "projetos", "calendario", "dashboard", "vendas", "clientes", "orcamentos", "produtos", "atividades"],
    podeEditar: true,
    veLeadsDeTodos: true,
    podeCriarUsuarios: false,
    podeExcluir: true,
  },
  vendedor: {
    label: "Vendedor",
    emoji: "👤",
    color: "#6366f1",
    descricao: "Kanban e clientes próprios",
    paginas: ["prontuarios", "leads", "pacotes", "agenda", "faltas", "espera", "painel", "kanban", "negociacoes", "comissoes", "calendario", "clientes", "atividades"],
    podeEditar: true,
    veLeadsDeTodos: false,
    podeCriarUsuarios: false,
    podeExcluir: false,
  },
  visualizador: {
    label: "Visualizador",
    emoji: "👁️",
    color: "#3b82f6",
    descricao: "Somente leitura, sem editar",
    paginas: ["prontuarios", "leads", "pacotes", "agenda", "faltas", "espera", "painel", "kanban", "dashboard", "atividades"],
    podeEditar: false,
    veLeadsDeTodos: true,
    podeCriarUsuarios: false,
    podeExcluir: false,
  },
  analista: {
    label: "Analista de Projetos",
    emoji: "📐",
    color: "#0d9488",
    descricao: "Operacional, sem valores financeiros",
    paginas: ["prontuarios", "leads", "negociacoes", "orcamentos", "projetos", "produtos", "atividades", "clientes", "calendario"],
    podeEditar: true,
    veLeadsDeTodos: true,
    podeCriarUsuarios: false,
    podeExcluir: false,
    verValores: false,
  },
  rh: {
    label: "RH",
    emoji: "🧑",
    color: "#0891b2",
    descricao: "Recursos Humanos (colaboradores)",
    paginas: ["prontuarios", "rh"],
    podeEditar: true,
    veLeadsDeTodos: false,
    podeCriarUsuarios: false,
    podeExcluir: true,
  },
};

export const NAV_ITEMS = [
  { id: "kanban",        label: "Kanban",     emoji: "📋" },
  { id: "atividades",    label: "Atividades", emoji: "✅" },
  { id: "calendario",    label: "Calendário", emoji: "📅" },
  { id: "dashboard",     label: "Dashboard",  emoji: "📊" },
  { id: "vendas",        label: "Vendas",     emoji: "🏆" },
  { id: "clientes",      label: "Clientes",   emoji: "✅" },
  { id: "orcamentos",    label: "Orçamentos", emoji: "🧾" },
  { id: "produtos",      label: "Produtos",   emoji: "📦" },
  { id: "historico",     label: "Histórico",  emoji: "🕓" },
  { id: "usuarios",      label: "Time",       emoji: "👥" },
  { id: "configuracoes", label: "Config",     emoji: "⚙️" },
];

export function getPerfil(role) {
  return PERFIS[role] || PERFIS.vendedor;
}

export function temAcesso(role, pagina) {
  const perfil = getPerfil(role);
  return perfil.paginas.includes(pagina);
}

export function podeEditar(role) {
  return getPerfil(role).podeEditar;
}

export function podeExcluir(role) {
  return getPerfil(role).podeExcluir;
}

export function veLeadsDeTodos(role) {
  return getPerfil(role).veLeadsDeTodos;
}

export function podeVerValores(role) {
  return getPerfil(role).verValores !== false;
}
